import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_NCS_REQUEST,
  DELETE_NC_REQUEST,
} from './types';

const deleteNC = (payload) => ({
  type: DELETE_NC_REQUEST,
  payload,
});

const getNCs = (payload) => ({
  type: GET_NCS_REQUEST,
  payload,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export { getNCs, initReducer, clearErrors, createErrors, deleteNC };
